export default function Input({
  name,
  type,
  value,
  onChange,
  handleNext,
  step,
}) {
  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm/6 font-medium text-gray-900"
      >
        {name}
      </label>
      <div className="mt-0">
        <input
          id={name}
          name={name}
          type={type}
          required
          value={value}
          onChange={(e) => onChange(e)}
          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
        />
      </div>
      {/**step == 3 && (
          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleNext}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Next
            </button>
          </div> 
        )*/}
    </div>
  );
}
